<template>
	<div class="mr-3">
		<div class="row">
			<div class="col-lg-12">
				<div class="table-finanzas mt-4">
					<table class="table-fin-spendplan">
						<thead>
							<tr>
								<th style="min-width:150px;max-width:152px">Fecha</th>
								<th style="min-width:150px;max-width:152px">Sueldo Base</th>
								<th style="min-width:150px;max-width:152px">Horas Extra</th>
								<th style="min-width:150px;max-width:152px">Comisiones y Bonos</th>
								<th style="min-width:150px;max-width:152px">Descuentos</th>
								<th style="min-width:150px;max-width:152px">Total</th>
								<th style="min-width:150px;max-width:152px">Obligaciones de Ley</th>
								<th style="min-width:150px;max-width:152px">Beneficios</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item,index) in Detalle" :key="index">
								<td style="min-width:150px;max-width:152px">
									<v-date-picker v-model="item.Fecha" :mode="typeCalendar" @input="Imprimir(item)"
									:popover="{
										placement: 'bottom',
										visibility: 'click'
									}"
									:input-props="{
										class: 'form-control cal-black',
										style: 'cursor:pointer;'
									}"
									:locale="'es-MX'"
								/>
								</td>
								<td style="min-width:150px;max-width:152px">
									<vue-numeric @keyup.native="CalcularTotal(index);IgualarDatos(index)" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.SueldoBase" placeholder="$ 0"/>
								</td>
								<td style="min-width:150px;max-width:152px">
									<vue-numeric @keyup.native="CalcularTotal(index);IgualarDatos(index)" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.HorasExtra" placeholder="$ 0"/>
								</td>
								<td style="min-width:150px;max-width:152px">
									<vue-numeric @keyup.native="CalcularTotal(index);IgualarDatos(index)" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Comisiones" placeholder="$ 0"/>
								</td>
								<td style="min-width:150px;max-width:152px">
									<vue-numeric @keyup.native="CalcularTotal(index);IgualarDatos(index)" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Descuentos" placeholder="$ 0"/>
								</td>
								<td style="min-width:150px;max-width:152px">
									<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Total" placeholder="$ 0"/>
								</td>
								<td style="min-width:150px;max-width:152px">
									<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Obligaciones" placeholder="$ 0"/>
								</td>
								<td style="min-width:150px;max-width:152px">
									<vue-numeric :disabled="true" class="form-control form-control-sm text-center bold" currency="$" separator="," :precision="0" v-model="item.Beneficios" placeholder="$ 0"/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:'FormDetalle',
	props:['pEmitSeccion'],
	data() {
		return {
			Detalle:[],
			IndexArray:0,
			Cargando:false
		}
	},
	methods: {
		Imprimir(item){
			// console.log(item.Fecha);
		},
		CalcularTotal(Index){
			let SueldoBase=isNaN(parseInt(this.Detalle[Index].SueldoBase)) ? 0 : parseInt(this.Detalle[Index].SueldoBase);
			let HorasExtra=isNaN(parseInt(this.Detalle[Index].HorasExtra)) ? 0 : parseInt(this.Detalle[Index].HorasExtra);
			let Comisiones=isNaN(parseInt(this.Detalle[Index].Comisiones)) ? 0 : parseInt(this.Detalle[Index].Comisiones);
			let Descuentos=isNaN(parseInt(this.Detalle[Index].Descuentos)) ? 0 : parseInt(this.Detalle[Index].Descuentos);
			this.Detalle[Index].Total=(SueldoBase+HorasExtra+Comisiones)-Descuentos;
		},
		IgualarDatos(Index){
			// if (this.Cargando) return;
			
			if (Index==0 && this.Detalle.length>1) {
				for (let i = 1; i < this.Detalle.length; i++) {
					this.Detalle[i].SueldoBase=this.Detalle[0].SueldoBase;
					this.Detalle[i].HorasExtra=this.Detalle[0].HorasExtra;
					this.Detalle[i].Comisiones=this.Detalle[0].Comisiones;
					this.Detalle[i].Descuentos=this.Detalle[0].Descuentos;
					this.CalcularTotal(i);
				}
			}
		},
		EnviarTotal(){
			this.bus.$emit('EnviarDetalle',this.Detalle,this.IndexArray);
			$('#formdetalle').modal("hide");
		}
	},
	created() {
		this.bus.$off('PassDetalles');
		this.bus.$on('PassDetalles',(Detalle,IndexArray)=>{
			this.Cargando=true;
			this.Detalle=Detalle.map(value => ({...value}));
			this.IndexArray=IndexArray;
			this.$nextTick(() => {
    			this.Cargando = false;
  			});
		});
		this.bus.$off('Save_'+this.pEmitSeccion);
        this.bus.$on('Save_'+this.pEmitSeccion,()=>{
            this.EnviarTotal();
        });
	},
	computed:{
		typeCalendar: function() {
			return "single";
		},
	}
}
</script>

<style>

</style>
